import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { SpAssetManagerRoutingModule } from './sp-asset-manager-routing.module';
import { SpAssetManagerComponent } from './sp-asset-manager.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [
    SpAssetManagerComponent
  ],
  exports: [

  ],
  imports: [
    CommonModule,
    SpAssetManagerRoutingModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatSortModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class SpAssetManagerModule {}
